import { useCallback, useState } from "react";
import { api } from "services/api.service";
import { useAlert } from "./useAlert";
import { LogisticsTicketVendor } from "types/logisticsTicket";

export type VendorContactPayload = {
  contactName: string;
  email: string;
  phone: string;
};

export default function useVendorContact() {
  const [submitting, setSubmitting] = useState(false);
  const { alertError, alertSuccess } = useAlert();

  const updatePrimaryContact = useCallback(
    (vendorUuid: string, contact: VendorContactPayload) => {
      setSubmitting(true);

      return api
        .put<LogisticsTicketVendor>(`/vendors/${vendorUuid}`, { vendor: contact })
        .then(({ data }) => {
          alertSuccess("Primary contact saved");
          return data;
        })
        .catch(() => {
          alertError("Unable to save vendor contact. Please try again.");
          return Promise.reject();
        })
        .finally(() => {
          setSubmitting(false);
        });
    },
    [alertError, alertSuccess],
  );

  return { updatePrimaryContact, submitting };
}
